<section class="flex min-h-[calc(100vh-5rem)] items-center justify-center px-gutter py-12">
  <div class="sx-card w-full max-w-md">
    <h1 class="font-display text-2xl font-extrabold text-primary">Reset Password</h1>
    <p class="mt-2 text-sm text-on-surface-variant">Set a new password using the token from your email.</p>
    <form class="mt-8 space-y-4" [formGroup]="form" (ngSubmit)="submit()">
      <div>
        <label class="sx-label" for="email">Email</label>
        <input id="email" class="sx-input" type="email" formControlName="email" />
      </div>
      <div>
        <label class="sx-label" for="token">Reset token</label>
        <input id="token" class="sx-input" formControlName="token" />
      </div>
      <div>
        <label class="sx-label" for="newPassword">New password</label>
        <input id="newPassword" class="sx-input" type="password" formControlName="newPassword" />
      </div>
      @if (message) {
        <p class="text-sm font-medium" [class.text-success]="success" [class.text-error]="!success">{{ message }}</p>
      }
      <button type="submit" class="sx-btn-primary w-full" [disabled]="form.invalid || submitting">
        {{ submitting ? 'Updating...' : 'Reset password' }}
      </button>
    </form>
    <a routerLink="/login" class="mt-6 inline-block text-sm font-semibold text-secondary hover:text-primary">Back to login</a>
  </div>
</section>
